import Vue from 'vue';

export default {
  setReportColumns(state, data){
    state.reportColumns = data;
  },
  changePaginationItemLimit(state, value){
    state.paginationItemsLimit = value;
  },
  setReportPaginationFilter(state, value){
    state.paginationLimit = value;
  },
  setUpdatingStatus(state, value){
    state.isNeedToUpdate = value;
  },
  setChartUpdatingStatus(state, value){
    state.isNeedToUpdateChart = value;
  },
  setReportSearch(state, value){
    state.searchPhrase = value;
  },
  setPagination(state, value){
    state.pagination.cursor = value.cursor;
    state.pagination.direction = value.direction;
  },
  clearPagination(state){
    state.pagination.cursor = null;
    state.pagination.direction = null;
  },
  startLoading(state){
    state.loadingStatus++;
  },
  finishLoading(state){
    state.loadingStatus--;
  },
  updatePresetStatus(state, value){
    state.presetUpdated = value;
  },
  setDateComparisonStatus(state, value){
    state.dateComparisonStatus = value;
  },


  setFilters(state, filters){
    state.filters = filters;
  },
  setAdvancedFilters(state, advancedFilters){
    state.advancedFilters = advancedFilters;
  },
  updateFilter(state, filterData){
    let field = filterData.field;
    let value = filterData.value;

    state.filters = { ...state.filters, [field]: value};
  },
  updateAdvancedFilter(state, filterData){
    let field = filterData.field;
    let value = filterData.value;

    state.advancedFilters = { ...state.advancedFilters, [field]: value};
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/baseReport/filter/mutations.js